export default __webpack_public_path__ + "static/media/logo-brin.ce0b4521.png";